import { Button, Divider, Form, Input, Space } from "antd";
import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { TipoTaxaImpostoModel } from "../../../../models/tipoTaxaImposto/tipoTaxaImpostoModel";
import { atualizarTipoTaxaImposto, cadastrarTipoTaxaImposto } from "../../../../services/tipoTaxaImpostoService";
import { setModalCadastrarTipoTaxaImposto } from "../../../../redux/slices/tipoTaxaImposto/tipoTaxaImpostoSlice";

const CadastroTipoTaxaImposto = () => {
  //estados globais
  const tipoTaxaImpostoState = useAppSelector((state) => state.tipoTaxaImposto);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<TipoTaxaImpostoModel>();

  const editar = Object.values(tipoTaxaImpostoState.entity).length !== 0;

  const inputInicial = useRef<any>(null);

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    if (editar) {
      form.setFieldsValue({
        ...tipoTaxaImpostoState.entity,
      });
    }
  }, [tipoTaxaImpostoState.entity]);

  const submit = (values: any) => {
    if (editar) {
      const updateTipoTaxaImposto = { id: tipoTaxaImpostoState.entity.id, ...values };
      dispatch(atualizarTipoTaxaImposto({ value: updateTipoTaxaImposto, busca: tipoTaxaImpostoState.busca }));
    } else {
      dispatch(cadastrarTipoTaxaImposto({ value: values, busca: tipoTaxaImpostoState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarTipoTaxaImposto(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Form.Item
        label="Denominação"
        name="denominacao"
        rules={[
          {
            required: true,
            message: "Digite o nome da taxa/imposto",
          },
        ]}
      >
        <Input type="text" ref={inputInicial} />
      </Form.Item>
      <Divider />
      <div className="modalFooter">
        <Space size="middle">
          <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
            FECHAR
          </Button>
          <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
            {editar ? "ATUALIZAR" : "SALVAR"}
          </Button>
        </Space>
      </div>
    </Form>
  );
};

export default CadastroTipoTaxaImposto;
